// DEPENDENCIES
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import { connect } from 'react-redux';
import SVGInline from 'react-svg-inline'

// INNER IMPORTS
import {isEmailValid, isMobile, isPasswordInvalid} from '../../utils';
import { connection } from '../../Config/Settings';
import { Checkbox } from '../Elements/Inputs';

// actions
import * as actions from '../../Actions/users';
import { openPayingMethodsModal } from '../../Actions/main';

// svgs
import dotsSVG from '../inlineSVGs/dotsSVG';
import signUpMugicsSVG from '../inlineSVGs/signUpMugicsSVG';
import closeCrossSVG from '../inlineSVGs/closeCrossSVG';

// slyles
import './Signup.css';
import {AnalyticsService} from "../../Services";

class SignupModal extends Component {
    constructor() {
        super();
        this.state = {email: "", emailagain: "", password: "", isAcceptTerms: false};
    }
    // Every time the user changes the email/password field, the state changes accordingly
    updateEmail(event) {
        this.setState({
            email: event.target.value.toLowerCase()
        })
    }
    updateEmailAgain(event) {
        this.setState({
            emailagain: event.target.value.toLowerCase()
        })
    }
    updatePassword(event) {
        this.setState({
            password: event.target.value
        })
    }
    signup() {
        this.setState({ message: null});
        if (this.state.email!==this.state.emailagain) {
            return this.setState({ message: "Email address fields are not the same."});
        }

        if (!isEmailValid(this.state.email)) {
            return this.setState({ message: "Email address is invalid."});
        }

        let passwordMessage = isPasswordInvalid(this.state.password);
        if (passwordMessage) {
            return this.setState({ message: passwordMessage});
        }

        if (!this.state.isAcceptTerms) {
            return this.setState({message: 'You must accept Terms of Use to continue'})
        }


        let pinDataWaiting = this.props.pinDataWaiting;
        // let filesWaiting = this.props.filesWaiting;

        this.props.signupCall(this.state, !!pinDataWaiting).then((err)=> {

            if (err) {
                return;
            }

            AnalyticsService.sendEvent(AnalyticsService.events.SIGN_UP, 'email', null, { type: 'email'});

            if (pinDataWaiting) {
                this.props.closeModal();
                this.props.openPayingMethodsModal();
                // this.props.savePin(this.props.token, pinDataWaiting, filesWaiting);
            }

            this.props.closeModal();
        });
    }

    handleSocialLogin(type) {
        AnalyticsService.sendEvent(AnalyticsService.events.SIGN_UP, type, null, { type });

        window.location.href = `${connection().serverUrl}/auth/${type}`
    }

    renderTitle(lang) {
        if (!this.props.signupTextType) return <div className="title">הי, נעים להכיר</div>

        if (lang === 'he') {
            return (
                <div className="title">
                    <p>כדי לפרסם מודעה</p>
                    <p>עלייך להיות חלק מ-Mugics</p>
                    <p>אז...?</p>
                    <p>כל כך פשוט להרשם!</p>
                </div>
            )
        }

        return (
            <div className="title">
                <p>To fill out the form</p>
                <p>you must be mugics member!</p>
                <p>so....?</p>
                <p>Yes! Sure! Definitely mamamia!</p>
                <p>Signing up is so easy!</p>
            </div>
        )
    }

    handleDateOverly() {
        if (!this.props.isSubmitModalOpen) return;

        this.dateDom = document.querySelector('.react-datepicker__tether-element');

        if (!this.dateDom || !this.dateDom.style || this.dateDom.style.display === 'none') return;

        this.dateDom.style.display = 'none';
    }

    render() {
        this.handleDateOverly();

        return (
            <div className="signup">
                <Modal
                    isOpen={this.props.isModalOpen}
                    contentLabel="Sign up"
                    className={`signupModal rtl ${!isMobile() ? 'large' : ''}`}
                    style={{overlay: {
                            backgroundColor: 'rgba(0, 0, 0, 0)'
                        }}}
                >
                    <div onClick={this.props.closeModal} >
                        <SVGInline className="closeButton" svg={closeCrossSVG} component="i"/>
                    </div>
                    <div className="content rtl">
                        <SVGInline svg={signUpMugicsSVG} component="i" className="signupBackImg1"/>
                        <SVGInline svg={dotsSVG} component="i" className="signupBackImg2"/>
                        {this.renderTitle('he')}
                        <div className="form">
                            <input className="signup-input" type="text" name="email" placeholder="מייל" onChange={this.updateEmail.bind(this)}/>
                            <input className="signup-input" type="text" name="emailagain" placeholder="אימות מייל" onChange={this.updateEmailAgain.bind(this)}/>
                            <input className="signup-input" type="password" name="password" placeholder="סיסמא" onChange={this.updatePassword.bind(this)}/>
                            <div className="message">{this.state.message || this.props.message}</div>
                            <div className="terms-and-services">
                                <Checkbox
                                    isChecked={this.state.isAcceptTerms}
                                    style={{ marginRight: 0 }}
                                    toggle={() => this.setState({isAcceptTerms: !this.state.isAcceptTerms})}
                                />
                                <label className="terms-text-label">
                                    <span> אני מסכים ל</span>
                                    <a href="http://terms.mugics.com/terms-and-conditions.html" target="_blank" rel="noopener noreferrer">תנאי שימוש</a> ו <a
                                    href="http://terms.mugics.com/privacy.html" target="_blank" rel="noopener noreferrer">מדיניות פרטיות</a>
                                    <span>של Mugics.</span>
                                </label>
                            </div>
                            <button onClick={this.signup.bind(this)}>בואו נתחיל!</button>
                        </div>
                        <div className="line">
                            <div className="connectWith">או התחברו דרך...</div>
                        </div>
                        <div className="connectWithButtons">
                            <div className="facebookButton" onClick={() => this.handleSocialLogin('facebook')}>FACEBOOK</div>
                            <div className="googleButton" onClick={() => this.handleSocialLogin('google')}>GOOGLE</div>
                        </div>
                        <div className="loginText">
                            <div className="login">כבר יש לך חשבון?</div>
                            <div className="loginhere" onClick={this.props.changeToLogin}>להתחברות</div>
                        </div>
                    </div>
                </Modal>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        message: state.users.signupMessage,
        pinDataWaiting: state.users.pinDataWaiting,
        filesWaiting: state.users.filesWaiting,
        token: state.users.token,
        signupTextType: state.users.signupTextType,
        isSubmitModalOpen: state.users.isSubmitModalOpen
    };
}

SignupModal.propTypes = {
    programActivated: PropTypes.bool,
    openPayingMethodsModal: PropTypes.func,
    closeModal: PropTypes.func,
    isModalOpen: PropTypes.bool,
    signupCall: PropTypes.func,
    signupTextType: PropTypes.string,
    isSubmitModalOpen: PropTypes.bool
};

// connecting redux state to the component props
export const SignupModalContainer = connect(mapStateToProps, {...actions, openPayingMethodsModal})(SignupModal);

export default SignupModal;



// WEBPACK FOOTER //
// ./src/Components/Users/Signup.js